import styled from "styled-components";

export const InlineImageSpan = styled.span<{ width: string; height: string; imageVerticalAlign: string }>`
    display: inline-block;
    vertical-align: ${props => props.imageVerticalAlign};
    width: ${props => props.width};
    height: ${props => props.height};
`;

export const WrapperContainer = styled.div`
    margin: calc(${props => props.theme.spacing.medium} * -1) ${props => props.theme.spacing.medium} 0;
`;
